export default __webpack_public_path__ + "static/media/asktheexpertban.20b461f9.png";